import { Navigate, Outlet, useLocation } from "react-router-dom";
import { usePortal } from "../../context/PortalsContext";

/**
 * Guards routes by portal page visibility (portalPages from getPortals DDL).
 * If the current path is listed in the selected portal's portalPages with
 * isVisible false, redirects to the access denied (401) page.
 */
export const PortalPageVisibilityGuard: React.FC = () => {
  const { pathname } = useLocation();
  const { portals } = usePortal();
  const portalPages = portals.selectedPortal?.portalPages;

  if (!portalPages?.length) {
    return <Outlet />;
  }

  const pageConfig = portalPages.find(
    (p) => pathname === p.path || pathname.startsWith(`${p.path}/`),
  );

  if (pageConfig && !pageConfig.isVisible) {
    return <Navigate to="/error/401" replace />;
  }

  return <Outlet />;
};
